var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginbg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1366px",
    height: "472px",
    viewBox: "0 0 1366 472",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4440D5BE-BB54-4183-A806-20722829C5EE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.7329503%",
    y1: "50.735091%",
    x2: "18.6243087%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0474DA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#044E92",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1366,0 L1366,472 L87,472 C38.9512268,472 5.88427763e-15,433.048773 0,385 L0,0 L0,0 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login-bg-1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#389AF3",
    opacity: 0.29031808,
    mask: "url(#mask-3)",
    cx: 869.5,
    cy: 127,
    rx: 323.5,
    ry: 313
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginbg);
export default __webpack_public_path__ + "static/media/loginbg.71d4f58efbb21908b3b83e85a360d9dc.svg";
export { ForwardRef as ReactComponent };